import { SeatCategory } from '@src/components/sco/Advisors/types'
import {
  LuAward,
  LuBriefcase,
  LuCircleDollarSign,
  LuLayoutGrid,
  LuScale,
  LuStar,
  LuTarget,
  LuTrendingUp,
  LuUsers,
} from 'react-icons/lu'

export const SEAT_CATEGORIES: SeatCategory[] = [
  {
    key: 'funding',
    name: 'Funding',
    palette: 'green',
    icon: LuTrendingUp,
    role: 'Helps you raise — opens warm investor doors and tightens your round before you go out to market.',
    skills: [
      'Seed fundraising',
      'Angel networks',
      'Pitch & deck',
      'Term sheets',
      'Valuation',
      'VC introductions',
    ],
    dos: [
      'Make warm investor intros',
      'Review my pitch deck',
      'Coach me through investor calls',
      'Help me set my raise terms',
    ],
  },
  {
    key: 'customer-acquisition',
    name: 'Customer acquisition',
    palette: 'orange',
    icon: LuTarget,
    role: 'Lands your first paying customers and builds the repeatable sales motion your team can scale.',
    skills: [
      'Sales motion',
      'Enterprise sales',
      'Pipeline',
      'Pilots → paid',
      'GTM playbook',
      'Channel partners',
    ],
    dos: [
      'Open doors to first customers',
      'Review my sales pitch',
      'Build my sales playbook',
      'Sit in on key deals',
    ],
  },
  {
    key: 'product',
    name: 'Product',
    palette: 'purple',
    icon: LuLayoutGrid,
    role: 'Sharpens your product direction, prioritization, and what to build next.',
    skills: ['Product strategy', 'UX & design', 'Roadmapping', 'Activation', 'PLG', 'User research'],
    dos: ['Pressure-test my roadmap', 'Review my product', 'Help me prioritize', 'Set up user research'],
  },
  {
    key: 'engineering-tech',
    name: 'Engineering & Tech',
    palette: 'blue',
    icon: LuBriefcase,
    role: 'Hardens your architecture and gets you enterprise- and security-ready before it blocks a deal.',
    skills: ['Architecture', 'Security / SOC 2', 'Scaling', 'Technical hiring', 'Infra', 'Code review'],
    dos: [
      'Review my architecture',
      'Get me SOC 2-ready',
      'Be my technical sounding board',
      'Vet engineering hires',
    ],
  },
  {
    key: 'team-hiring',
    name: 'Team & Hiring',
    palette: 'pink',
    icon: LuUsers,
    role: 'Helps you hire your first key people — define the roles and land the right talent without overpaying.',
    skills: ['First hires', 'Recruiting', 'Comp & equity', 'Org design', 'Culture', 'Performance'],
    dos: [
      'Source strong candidates',
      'Help define key roles',
      'Advise on comp & equity',
      'Sit on hiring panels',
    ],
  },
  {
    key: 'ops-finance',
    name: 'Operations & Finance',
    palette: 'yellow',
    icon: LuCircleDollarSign,
    role: 'Gets your finances, cap table, and day-to-day operations in order so nothing surprises you.',
    skills: ['Financial modeling', 'Cap table', 'Budgeting', 'Legal', 'Tax', 'Fundraise ops'],
    dos: ['Build my financial model', 'Review my cap table', 'Set up my operations', 'Advise on legal & tax'],
  },
  {
    key: 'design-brand',
    name: 'Design & Brand',
    palette: 'teal',
    icon: LuStar,
    role: 'Shapes how your product looks and feels — brand identity, visual design, and the experience users see.',
    skills: [
      'Brand identity',
      'Visual design',
      'UX & UI',
      'Product design',
      'Web & landing',
      'Design systems',
    ],
    dos: [
      'Review my brand & identity',
      'Design my landing page',
      'Sharpen my visual design',
      'Build a design system',
    ],
  },
  {
    key: 'legal',
    name: 'Legal',
    palette: 'blue',
    icon: LuScale,
    role: 'Keeps your company clean — formation, contracts, IP, and the compliance questions that trip up early teams.',
    skills: [
      'Formation & cap table',
      'Contracts & NDAs',
      'IP & trademarks',
      'Employment law',
      'Fundraise docs',
      'Compliance',
    ],
    dos: [
      'Review my founder agreement',
      'Tighten customer contracts',
      'Walk me through a SAFE',
      'Flag IP risks before we ship',
    ],
  },
  {
    key: 'leadership',
    name: 'Leadership & Strategy',
    palette: 'purple',
    icon: LuAward,
    role: "A founder who's been there to steady your biggest calls and keep you clear of the classic early traps.",
    skills: [
      'Strategy',
      'Board management',
      'Fundraise strategy',
      'Founder coaching',
      'Decision-making',
      'Scaling',
    ],
    dos: [
      'Be my founder coach',
      'Help me weigh big calls',
      'Coach me on board dynamics',
      'Steady the big decisions',
    ],
  },
]
